import { type FC } from 'react';

const HomePage: FC = () => {
  return <div></div>;
};

export default HomePage;
